import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getSelection, $isRangeSelection } from "lexical";
import { useEffect, useState } from "react";

import { $ancestorProductContext } from "./ProductBlockPlugin";

/**
 * Whether the caret sits inside a Discover section — what gates the Discover
 * headline tag in the picker and typeahead. Reads the editor state's
 * selection, which survives blur, so a picker click still sees it.
 */
export function useCaretInDiscoverContext(): boolean {
  const [editor] = useLexicalComposerContext();
  const [inDiscover, setInDiscover] = useState(false);

  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        const selection = $getSelection();
        const anchor = $isRangeSelection(selection)
          ? selection.anchor.getNode()
          : null;
        setInDiscover(
          $ancestorProductContext(anchor)?.getModel() === "discover",
        );
      });
    });
  }, [editor]);

  return inDiscover;
}
